import styles from "./styles.module.css";
import { MdChevronRight } from "react-icons/md";

export default function Item({ name, data, onClick, active }) {
  return (
    <div
      onClick={onClick}
      className={active ? `${styles.item} ${styles.active}` : styles.item}
    >
      <div>{name}</div>
      <MdChevronRight className={styles.arrowIcon} />
    </div>
  );
}
